<template>
  <!-- edit vue transition -->
  <transition v-if="isPurchaseDeliveryAdmin || isPurchaseDeliverySupervisor" name="slide" mode="in-out">
    <b-container fluid class="px-3 main">
      <NavBar class="sticky-header py-3"/>
      <ScrollToBtn :threshold="150"/>
      <section class="px-1">
        <!-- render every child route component -->
        <router-view></router-view>
      </section>
    </b-container>
  </transition>
  <NotFoundComponent v-else/>
</template>

<script>
import { mapGetters } from 'vuex'
import NavBar from './NavBar'
import ScrollToBtn from '../../shared/ScrollToBtn'
import NotFoundComponent from '../../NotFoundComponent.vue'
export default {
  name: "PurchaseDeliveryLayout",
  components : { NavBar, ScrollToBtn, NotFoundComponent},
  computed: {
    ...mapGetters(['isPurchaseDeliveryAdmin', 'isPurchaseDeliverySupervisor'])
  }
}
</script>

<style lang="scss" scoped>
.main {
  scroll-behavior: smooth;
}

.slide-enter-active {
  transition: opacity 1s, transform 1s;
}
// .slide-leave-active {
// }

.slide-enter {
  opacity: 0;
  transform: translateX(10%);
}
// .slide-leave-to {
// }

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 4 !important;
}
</style>